import { useQueryClient } from "@tanstack/react-query";

import { useDeleteTestingControls } from "../../../../../api/generated/testing-controls/testing-controls";
import { TESTING_CONTROLS_QUERY_KEY } from "../../list/queries/useTestingProgramTestingControlsQuery";

import { getTestingControlQueryKey } from "./useTestingControlQuery";

export function useDeleteTestingControlMutation() {
    const queryClient = useQueryClient();
    return useDeleteTestingControls({
        mutation: {
            onSuccess: (_data, vars) => {
                queryClient.invalidateQueries({
                    queryKey: [TESTING_CONTROLS_QUERY_KEY],
                });
                for (const id of vars.data) {
                    queryClient.invalidateQueries({
                        queryKey: getTestingControlQueryKey(id),
                    });
                }
            },
        },
    });
}
